import React from 'react';
import {Grid, TextField} from '@mui/material';

/**
 * Pure controlled form for {@link MachineTechProfileUpdateDto}: 12 numeric
 * fields with min/max bounds that mirror the bean-validation on the entity
 * ({@code MachineTechProfileDto}). Bounds live in one place ({@link FIELDS})
 * — no duplication, easy to keep aligned with the backend on review.
 *
 * Shape: each field on the DTO ({@code gameTime, useDefaultSetting,
 * graspPower, …, winChance}).
 *
 * `winChance` is a 0..1 Double; the rest are Integers with explicit min/max.
 */

const FIELDS = [
    {key: 'gameTime',          label: 'Game Time',           type: 'int',   min: 1},
    {key: 'useDefaultSetting', label: 'Use Default Setting', type: 'int',   min: 0,  max: 1},
    {key: 'graspPower',        label: 'Grasp Power',         type: 'int',   min: 1,  max: 48},
    {key: 'topPower',          label: 'Top Power',           type: 'int',   min: 1,  max: 48},
    {key: 'movePower',         label: 'Move Power',          type: 'int',   min: 1,  max: 48},
    {key: 'maxPower',          label: 'Max Power',           type: 'int',   min: 1,  max: 48},
    {key: 'topHeight',         label: 'Top Height',          type: 'int',   min: 0,  max: 10},
    {key: 'lineLength',        label: 'Line Length',         type: 'int',   min: 10, max: 35},
    {key: 'xSpeed',            label: 'X Speed',             type: 'int',   min: 1,  max: 5},
    {key: 'ySpeed',            label: 'Y Speed',             type: 'int',   min: 1,  max: 5},
    {key: 'zSpeed',            label: 'Z Speed',             type: 'int',   min: 1,  max: 5},
    {key: 'winChance',         label: 'Win Chance',          type: 'float', min: 0,  max: 1, step: 0.01},
];

const parseValue = (rawString, type) => {
    if (rawString === '') return null;
    const n = type === 'int' ? parseInt(rawString, 10) : parseFloat(rawString);
    return Number.isFinite(n) ? n : null;
};

const MachineTechProfileForm = ({value, onChange}) => {
    const set = (key, raw, type) => onChange({...value, [key]: parseValue(raw, type)});

    return (
        <Grid container spacing={2}>
            {FIELDS.map(({key, label, type, min, max, step}) => (
                <Grid key={key} size={{xs: 12, sm: 6, md: 4}}>
                    <TextField
                        type="number"
                        label={label}
                        value={value?.[key] ?? ''}
                        onChange={(e) => set(key, e.target.value, type)}
                        inputProps={{
                            min,
                            ...(max !== undefined ? {max} : {}),
                            ...(step !== undefined ? {step} : {}),
                        }}
                        fullWidth
                        size="small"
                        required
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default MachineTechProfileForm;
